import { render, staticRenderFns } from "./courseInterval.vue?vue&type=template&id=0d019b26&scoped=true"
import script from "./courseInterval.vue?vue&type=script&lang=js"
export * from "./courseInterval.vue?vue&type=script&lang=js"
import style0 from "./courseInterval.vue?vue&type=style&index=0&id=0d019b26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d019b26",
  null
  
)

export default component.exports